




























import { Component, Prop, Ref, Vue } from 'vue-property-decorator'
import { ProviderInstance } from 'vee-validate/dist/types/types'

@Component
export default class InputFieldType extends Vue {
    @Prop({ required: true }) readonly value!: string
    @Prop({ default: 'fields' }) readonly fieldType!: string
    @Prop() readonly name!: string
    @Prop({ default: null }) readonly rules!: string
    @Ref() validator!: ProviderInstance

    async selectValue(value): Promise<void> {
        if (this.value !== value) {
            await this.validator.validate(value)
            this.$emit('input', value)
        }
    }

    get groupedFieldTypes(): {[key: string]: string[]} {
        return {
            text: [
                'short_text',
                'long_text',
            ],
            number: [
                'number',
            ],
            date: [
                'date',
            ],
            structure: [
                // 'group',
                'statement',
            ],
            choices: [
                'multiple_choice',
                'picture_choice',
                'yes_no',
                'dropdown',
            ],
            rating: [
                'ranking',
                'opinion_scale',
                'rating',
                // 'matrix',
            ],
            contact: [
                'phone_number',
                'email',
                'website',
            ],
            payment: [
                'payment',
            ],
            file_upload: [
                'file_upload',
            ],
            legal: [
                'legal',
            ],
        }
    }

    fieldIcon(fieldType: string): string {
        return 'icon-typeform-' + fieldType.replace('_', '-')
    }
}
